import { Component, DimensionSet } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getStandardDimensions(component: Component) {
  // A post request, since get requests can't have bodies.
  return DesignService.post<DimensionSet>('dimensionSets', { data: component });
}

export function getDimensionSet(dimensionSetGuid: string) {
  return DesignService.get<DimensionSet>(`dimensionSets/${dimensionSetGuid}`);
}
